import { render, staticRenderFns } from "./bsp-dicts-select.vue?vue&type=template&id=2d81d918&scoped=true&"
import script from "./bsp-dicts-select.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-select.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-select.vue?vue&type=style&index=0&id=2d81d918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d81d918",
  null
  
)

export default component.exports